function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgBell = function SvgBell(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Bell' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("g", {
    transform: "translate(2.000000, 0.000000)",
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M2,38 L42,38 L42,35.143 C42,32.738 41.064,30.479 39.364,28.778 L35.222,24.636 C33.144,22.559 32,19.796 32,16.857 L32,12 C32,6.486 27.514,2 22,2 C16.486,2 12,6.486 12,12 L12,16.857 C12,19.796 10.856,22.559 8.778,24.636 L4.636,28.778 C2.936,30.479 2,32.738 2,35.143 L2,38 Z M17,40 L17,41 C17,43.757 19.243,46 22,46 C24.757,46 27,43.757 27,41 L27,40 L17,40 Z M22,48 C18.14,48 15,44.859 15,41 L15,40 L0,40 L0,35.143 C0,32.204 1.144,29.441 3.222,27.364 L7.364,23.222 C9.064,21.521 10,19.262 10,16.857 L10,12 C10,5.383 15.383,0 22,0 C28.617,0 34,5.383 34,12 L34,16.857 C34,19.262 34.936,21.521 36.636,23.222 L40.778,27.364 C42.856,29.441 44,32.204 44,35.143 L44,40 L29,40 L29,41 C29,44.859 25.86,48 22,48 L22,48 Z"
  })));
};

SvgBell = pure(SvgBell);
SvgBell.displayName = 'SvgBell';
export default SvgBell;